import { defineComponent as p, computed as s, openBlock as l, createElementBlock as c, mergeProps as k, createElementVNode as o, renderSlot as b, withModifiers as y, createVNode as _, createCommentVNode as h } from "vue";
import C from "./index60.js";
const A = { class: "flex items-center" }, v = { class: "list-item__content" }, E = /* @__PURE__ */ p({
  __name: "BaseListItem",
  props: {
    clickable: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    divider: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    secondaryAction: { default: void 0 }
  },
  emits: ["click", "secondaryActionClick"],
  setup(a, { emit: n }) {
    const t = a, i = n, d = s(() => {
      const e = ["list-item"];
      return t.clickable && e.push("list-item--clickable"), t.disabled && e.push("list-item--disabled"), t.divider && e.push("list-item--divider"), t.selected && e.push("list-item--selected"), e.join(" ");
    }), r = s(() => {
      const e = {};
      return t.clickable && (e.role = "button", e.tabindex = t.disabled ? -1 : 0), t.disabled && (e["aria-disabled"] = !0), t.selected && (e["aria-selected"] = !0), e;
    }), m = (e) => {
      t.clickable && i("click", e);
    }, f = (e) => {
      t.disabled || (e.stopPropagation(), i("secondaryActionClick", e));
    }, u = (e) => {
      t.clickable && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), i("click", e));
    };
    return (e, B) => (l(), c("li", k({ class: d.value }, r.value, {
      onClick: m,
      onKeydown: u
    }), [
      o("div", A, [
        o("div", v, [
          b(e.$slots, "content")
        ]),
        t.secondaryAction ? (l(), c("div", {
          key: 0,
          class: "list-item__secondary-action",
          onClick: y(f, ["prevent"])
        }, [
          _(C, {
            name: t.secondaryAction.name,
            size: "md"
          }, null, 8, ["name"])
        ])) : h("", !0)
      ])
    ], 16));
  }
});
export {
  E as default
};
